function cngMiniCart(data,view) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function (cart) {

            jQuery.getJSON('/cart.js', function (cart, textStatus) { 
                jQuery('#cart_count').html(cart.item_count); 
                if (jQuery('.totals__subtotal-value').length > 0) { 
                  jQuery('.totals__subtotal-value').html(Shopify.formatMoney(cart.total_price));
                }

              })
          
          return fetch('/cart?view='+view+'&timestamp=' + Date.now(), {
              credentials: 'same-origin',
              method: 'GET'
            }).then(function (content) {  
              content.text().then(function (html) { 
                  if (view == 'drawer') {
                    jQuery('#block_sidebar_cart').html(html);  
                  }
                  if (view == 'ajax') {
                    jQuery('.cart__items-block').html(html); 
                    return fetch('/cart?view=footer-ajax&timestamp=' + Date.now(), {
credentials: 'same-origin',
              method: 'GET'
              }).then(function (content) { 
content.text().then(function (html) { 
  jQuery('.cart-footer-totals-ajax').html(html);  
})
              })
                  }
                  
                   
                  
                }); 
            })
  
        },
        error: function (XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus)
        },
      }
      jQuery.ajax(params) 
}

function cngMiniCartVal(line_id,id_item,view) {
    quantity=jQuery('#updates_' + id_item).val(); 
    var data = {
        "id": line_id,
        "quantity": quantity
      } 
      cngMiniCart(data,view);
}

function delMiniCartVal(line_id,view) { 
    var data = {
        "id": line_id,
        "quantity": 0
      } 
      cngMiniCart(data,view);
}

function cngMiniCartQuantity(quantity,line_id,id_item,view) { 
    jQuery('#updates_' + id_item).val(quantity); 
    var data = {
        "id": line_id,
        "quantity": quantity
      }
      cngMiniCart(data,view);
}
 


/*function on_change_gift(line_key,id_item,view,line) {
  if (jQuery('#CartItem_'+line).find('.on_change_gift').prop('checked') == true) { 
     jQuery('#CartItem_'+line).find('.checkbox_items').addClass('active'); 
    jQuery('#CartItem_'+line+' .CartItem__LinePriceList input[type="checkbox"]').prop('checked',false);  
  } else {
     jQuery('#CartItem_'+line).find('.checkbox_items').removeClass('active'); 
    jQuery('#CartItem_'+line+' .CartItem__LinePriceList input[type="checkbox"]').prop('checked',true);  
  }
jQuery('#CartItem_'+line+' .CartItem__LinePriceList input[type="checkbox"]').click();
  ////hide below
  if (jQuery('#Linegift_'+id_item).prop('checked') == true) {
     jQuery('#Linegift_i_'+id_item).addClass('active'); 
    jQuery('#LinePriceList_'+id_item+' input[type="checkbox"]').prop('checked',false);  
  } else { 
    jQuery('#Linegift_i_'+id_item).removeClass('active');
    jQuery('#LinePriceList_'+id_item+' input[type="checkbox"]').prop('checked',true);
     
  }
  jQuery('#LinePriceList_'+id_item+' input[type="checkbox"]').click();
 ////
}*/





jQuery(document).on("click", '.mini-cart__checkout', function(event) { 
  
   if (jQuery('#carteffectiveAppsAgreeCB').length) {
      if (!document.getElementById('carteffectiveAppsAgreeCB').checked) { 
        jQuery.fancybox.close(); 
        jQuery.fancybox.open({
                      src: effective_apps_tac_alert,
                      type: 'html',
                      baseClass: 'effective_appsf'
                    }) 
         
        event.preventDefault;
        event.stopPropagation;
          return false;
      }
     }
   
  jQuery(".mini-cart-form-items").submit();
}); 
